<template>
    <Card class="card p-5 shadow-sm" :title="$t('events.nps.response.list')">
      <div class="row">
          <div v-if="responses?.length > 0" class="row g-6 g-xl-9">
              <div class="tableFixHead">
                  <table class="table align-middle table-row-dashed fs-6 fw-bold gy-4" id="datatable_nps_response">
                      <thead class="fw-bold fs-6" style="background-color: #F2F3F4;">
                          <tr class="fw-bolder fs-7 text-uppercase text-center gs-0">
                              <th class="text-center capitalize" >{{ $t('events.nps.response.name') }}</th>
                              <th class="text-center capitalize" >{{ $t('events.nps.response.note') }}</th>
                              <th class="text-center capitalize" >{{ $t('actions') }}</th>
                          </tr>
                      </thead>
                  
                      <tbody >
                          <tr  v-for="(resp, index) in responses" :key="index" style="cursor: pointer;">
                              <td class="text-center" > {{ resp?.contact ? resp?.contact?.firstname : resp?.email }} </td>
                              <td class="text-center" > {{ resp?.note }} </td>
                              <td @click="goToResponseOverview(resp?.id)" class="text-center" > <i class="fas fa-eye fs-2"></i> </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div> 
          <div v-if="responses?.length == 0 && !getting">
              <Card class="card p-5 h-full">
                  <div class=" text-center ">
                      <div class="pt-8 ">
                        <Img filename="empty.png" alt=""
                          class="mw-100 h-125px h-sm-175px" />
                      </div>
                      <h2 class="fs-2x fw-bolder mb-0">{{ $t('events.nps.noNpsResponseReceived') }}</h2>
                      <br>
                      <br>
                      <Button btn-class="btn-md" type="new" btn-text="nps.send_invitation" @click="handleSendInvitation"/>
                      <br>
                      <br>
                      <br>
                      <br>
                  </div>
              </Card>
          </div>
      </div> 
    </Card> 
    <NpsInvitationModal id="send_nps_invitation"/>
</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRouter, useRoute} from "vue-router";
import Button from "@/components/Button.vue";
import Card from "@/components/Card.vue";
import NpsInvitationModal from "../../components/Modal/NpsInvitationModal.vue";
import Img from "@/components/Img.vue";

const route = useRoute()
const router = useRouter()
const store = useStore()
const responses = ref([])
const getting = ref(false)

watch(() => route.query.tab, (value) => {
  if(value == 'tab-nps' && route.params.nps) {
    loadNpsResponses()
  }
})

async function loadNpsResponses() {
  getting.value = true
  await store.dispatch('eventNps/getNpsResponses', route.params.nps).then((res) => {
    responses.value = res?.data?.responses
  }).finally(() => {getting.value = false})
} 

const handleSendInvitation = () => {
    $('#send_nps_invitation').modal('toggle')
}

const goToResponseOverview = (response) => {
  router.push({name: 'events-nps-responses-details', params:{id: route.params.id, nps: route.params.nps, response}, query: { tab: route.query.tab || 'tab-nps' }})
}

onMounted(async() => {
  if(route.params.nps && route.query.tab == 'tab-nps'){
    loadNpsResponses()
  }
})

</script>

<style scoped>
  .password-input {
    position: relative;
  }

  .toggle-password {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  #eye-icon {
    font-size: 1.2em;
  }
</style>
